import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import api from "../../../helpers/api/Api";
import ApiUrls from "../../../helpers/urls/ApiUrls";
import { getGraphTitle } from "../../../components/GraphCard/functions/getGraphTitle";
import GraphCard from "../../../components/GraphCard/graphCard";
import PieChart from "../../../components/Charts/PieChart";
import {bTh} from "../../../helpers/functions/report-table";

function PieGraph({ graphData, index, handleGraphChange }) {
  const [chartData, setChartData] = useState();

  useEffect(() => {
    if (graphData) {
      getGraph();
    }
  }, [graphData]);

  const getGraph = () => {
    const fd = new FormData();
    fd.append("ip", graphData.ip);
    fd.append("item", graphData.item);
    fd.append("period", graphData.item === "disk" ? "day" : graphData.period);
    fd.append("domainid", "");

    api.post(ApiUrls.reports.getGraph, fd)
       .then((response) => {
         setData(response.data);
       })
       .catch((error) => {
       });
  }

  const setData = (res) => {
    const labels = [], data = [];

    if (graphData.item === "disk") {
      let total = 0;
      res.map((d) => {
        labels.push(d[0]);
        let value = d[1];
        data.push(value);
        total += value;
      });
      setChartData({ labels, data, total });
    } else {
      res[0].map((d) => {
        labels.push(d);
      });
      res[1].map((d) => {
        data.push(d);
      });
      sortData(data, labels);
    }
  }

  const sortData = (data, labels) => {
    let total = 0;

    let sortedLs = [...labels];
    sortedLs.sort();
    let sortedDs = [];

    for (let i = 0; i < sortedLs.length; i++) {
      let index = labels.indexOf(sortedLs[i]);
      let d = data[index];
      total += d;
      sortedDs.push(d);
    }

    setChartData({ labels: sortedLs, data: sortedDs, total });
  }

  return (
     <Grid item md={8} xs={12}>
       <GraphCard
          getChart={getGraph}
          graphData={graphData}
          title={getGraphTitle(graphData, "dashboard-graph")}
          handleGraphClear={() => handleGraphChange("remove", index)}
          clearable
       >
         <PieChart
            id={graphData.id}
            chart={{
              labels: chartData?.labels,
              datasets: chartData?.data,
              tooltipCallback: {
                label: function(context) {
                  let label = `${context.label}: `;
                  label += `${((context.raw/chartData?.total)*100).toFixed(1)}%`;
                  return label;
                }
              },
              legendFilter: function(legendItem, data) {
                const label = legendItem.text;
                const labelIndex = data.labels.findIndex((l) => l === label);
                const qtd = data.datasets[0].data[labelIndex];
                legendItem.text = `${legendItem.text}: ${bTh(qtd, "GB")}`;
                return true;
              }
            }}
         />
       </GraphCard>
     </Grid>
  );
}

export default PieGraph;
